const STORAGE_PREFIX = 'tms:column-settings:'
const CURRENT_VERSION = 1
const EMPTY_SETTINGS = Object.freeze({ version: CURRENT_VERSION, order: [], hidden: [] })

function storageKey(key) {
  return `${STORAGE_PREFIX}${key}`
}

export function getColumnSettings(key) {
  if (!key) return { ...EMPTY_SETTINGS }
  try {
    const raw = window.localStorage.getItem(storageKey(key))
    if (!raw) return { ...EMPTY_SETTINGS }
    const parsed = JSON.parse(raw)
    return {
      version: CURRENT_VERSION,
      order: Array.isArray(parsed.order) ? parsed.order : [],
      hidden: Array.isArray(parsed.hidden) ? parsed.hidden : []
    }
  } catch (e) {
    return { ...EMPTY_SETTINGS }
  }
}

export function setColumnSettings(key, settings) {
  if (!key) return
  const payload = {
    version: CURRENT_VERSION,
    order: Array.isArray(settings.order) ? settings.order : [],
    hidden: Array.isArray(settings.hidden) ? settings.hidden : []
  }
  window.localStorage.setItem(storageKey(key), JSON.stringify(payload))
}

export function clearColumnSettings(key) {
  if (!key) return
  window.localStorage.removeItem(storageKey(key))
}

function columnKey(column) {
  if (column && typeof column.dataIndex === 'string' && column.dataIndex !== '') return column.dataIndex
  if (column && typeof column.title === 'string' && column.title !== '') return column.title
  return null
}

export function mergeColumns(originalColumns, settings, lockedKeys = []) {
  const safeOriginal = Array.isArray(originalColumns) ? originalColumns : []
  const order = settings && Array.isArray(settings.order) ? settings.order : []
  const hidden = settings && Array.isArray(settings.hidden) ? settings.hidden : []
  const hiddenSet = new Set(hidden)
  const lockedSet = new Set(lockedKeys)

  const locked = []
  const withKeys = []
  const noKeys = []
  safeOriginal.forEach((col, idx) => {
    const k = columnKey(col)
    if (k === null) {
      noKeys.push({ col, idx })
    } else if (lockedSet.has(k)) {
      locked.push({ col, key: k, idx })
    } else {
      withKeys.push({ col, key: k, idx })
    }
  })

  const byKey = new Map(withKeys.map(item => [item.key, item]))
  const ordered = []
  const seenKeys = new Set()

  order.forEach(k => {
    const item = byKey.get(k)
    if (item && !seenKeys.has(k)) {
      seenKeys.add(k)
      ordered.push(item)
    }
  })

  withKeys.forEach(item => {
    if (!seenKeys.has(item.key)) {
      ordered.push(item)
    }
  })

  const visibleOrdered = ordered.filter(item => !hiddenSet.has(item.key))

  // 锁定列始终保持在最前，按原列顺序排列，且永远可见
  const result = locked.map(item => item.col)
  visibleOrdered.forEach(item => {
    result.push(item.col)
  })
  noKeys.forEach(item => {
    result.push(item.col)
  })

  return result
}
